import { devMessage, isDevEnv } from "../../../utils/devMessage";
var tryStyle = function(styleBuilder, componentName) {
    return function(theme, flags) {
        try {
            var style = styleBuilder(theme, flags);
            return function() {
                return style;
            };
        } catch (error) {
            isDevEnv(function() {
                return devMessage("[".concat(componentName, "] Error building style from theme! \nMost likely issues: \n1) ThemeProvider is not in your component tree (see Carina doc-site Developers/Themes) \n2) Tokens and/or ThemeProvider peer-dependencies are not using the correct version for this component"));
            });
            console.error(error);
            return {};
        }
    };
};
export default tryStyle;
